import { put, takeLeading } from "redux-saga/effects";
import handleNetworkError from "sagas/helpers/handleNetworkError";
import { post } from "sagas/helpers/network";

function* execute(action: sage.actions.jobs.ICancelJob) {
    yield put({
        type: "com.sage.actions.jobs.ISetCancelJobStatus",
        status: "loading",
    } as sage.actions.jobs.ISetCancelJobStatus);
    try {
        const response = yield post("/cancel-job", {
            job_id: action.jobId,
        });
        if (response.data != null) {
            yield put({
                type: "com.sage.actions.jobs.ISetJob",
                job: response.data,
            } as sage.actions.jobs.ISetJob);
            // refetch the tasks, they have chagned.
            yield put({
                type: "com.sage.actions.jobs.IFetchJobTasksUpdated",
                jobID: action.jobId,
                updatedAt: null,
            } as sage.actions.jobs.IFetchJobTasksUpdated);
            yield put({
                type: "com.sage.actions.jobs.ISetCancelJobStatus",
                status: "cancelled",
            } as sage.actions.jobs.ISetCancelJobStatus);
        } else {
            yield put({
                type: "com.sage.actions.jobs.ISetCancelJobStatus",
                status: "error",
            } as sage.actions.jobs.ISetCancelJobStatus);
        }
    } catch (e) {
        yield handleNetworkError(e);
        yield put({
            type: "com.sage.actions.jobs.ISetCancelJobStatus",
            status: "error",
        } as sage.actions.jobs.ISetCancelJobStatus);
    }
}

export default function* saga(): Generator {
    yield takeLeading("com.sage.actions.jobs.ICancelJob", execute);
}
